import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';

export const AlertFilter = ({ setFilters, filters }) => {
  const options = [
    { value: 1, label: 'Sin alertas' },
    { value: 2, label: 'Inmediatas' },
    { value: 3, label: 'Diarias' }
  ];

  const handleChange = selectedOption => {
    setFilters(state => ({
      ...state,
      alerts: selectedOption.value
    }));
  };

  return (
    <Form.Group>
      <Form.Label>Tipo de Alertas</Form.Label>
      <Select
        options={options}
        value={options.find(option => option.value === filters.alert)}
        onChange={handleChange}
        placeholder="Tipo de Alertas"
      />
    </Form.Group>
  );
};

AlertFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired
};
